import React, { useEffect, useMemo, useState } from 'react';

import { Button, FormGroup, Grid, makeStyles, Theme } from '@material-ui/core';
import { Search as SearchIcon } from '@mui/icons-material';

import { Control, useFormContext } from 'react-hook-form';

import { FilterFormData } from './FilterForm';
import Select from '../../../common/components/Select';

interface FilterFormFieldsProps {
  className: string;
  control: Control<FilterFormData, any>;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      boxShadow: 'none',
    },
    '& span': {
      marginBottom: '-3px',
    },
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: '#ffffff',
    height: '2.5rem',
    overflow: 'hidden',
  },
  buttonColumn: {
    alignItems: 'end',
    display: 'flex',
    marginBottom: '0.9375rem',
  },
  columnSpace: {
    marginRight: '1rem',
  },
  input: {
    marginBottom: 15,
  },
}));

const FilterFormFields = ({
  className = '',
  control,
  disabled = false,
}: FilterFormFieldsProps) => {
  const classes = useStyles();

  const [disableSecondSituation, setDisableSecondSituation] =
    useState<boolean>(true);

  const { watch, setValue } = useFormContext();

  const firstSituation = watch('firstSituation');

  useEffect(() => {
    setDisableSecondSituation(
      firstSituation === '' || firstSituation === 'Todos'
    );

    if (firstSituation === '' || firstSituation === 'Todos') {
      setValue('secondSituation', '');
    }
  }, [firstSituation, setValue]);

  return (
    <FormGroup className={className}>
      <Grid container>
        <Grid
          className={classes.columnSpace}
          item
          xs={3}
          style={{ maxWidth: '23%' }}
        >
          <Select
            className={classes.input}
            control={control}
            defaultValue={3}
            disabled={disabled}
            label="Previsão chegada"
            name="arrival"
            options={[
              { label: 'A partir de 3 dias atrás', value: 3 },
              { label: 'A partir de 7 dias atrás', value: 7 },
              { label: 'A partir de 15 dias atrás', value: 15 },
              { label: 'A partir de 30 dias atrás', value: 30 },
              { label: 'A partir de 60 dias atrás', value: 60 },
            ]}
          />
        </Grid>
        <Grid
          className={classes.columnSpace}
          item
          xs={3}
          style={{ maxWidth: '23%' }}
        >
          <Select
            className={classes.input}
            control={control}
            defaultValue="Todos"
            disabled={disabled}
            label="Situação 1"
            name="firstSituation"
            options={[
              { label: 'Todos', value: 'Todos' },
              { label: 'Atracados', value: 'Atracados' },
              { label: 'Esperados', value: 'Esperados' },
              { label: 'Desatracados', value: 'Desatracados' },
              { label: 'Na Barra', value: 'Na Barra' },
            ]}
          />
        </Grid>
        <Grid
          className={classes.columnSpace}
          item
          xs={3}
          style={{ maxWidth: '23%' }}
        >
          <Select
            className={classes.input}
            control={control}
            disabled={disableSecondSituation}
            label="Situação 2"
            name="secondSituation"
            options={[
              { label: 'Atracados', value: 'Atracados' },
              { label: 'Esperados', value: 'Esperados' },
              { label: 'Desatracados', value: 'Desatracados' },
              { label: 'Na Barra', value: 'Na Barra' },
            ]}
          />
        </Grid>
        <Grid
          className={classes.buttonColumn}
          item
          xs={3}
          style={{ maxWidth: '23%' }}
        >
          <Button className={classes.button} type="submit" variant="contained">
            <SearchIcon />
          </Button>
        </Grid>
      </Grid>
    </FormGroup>
  );
};

export default FilterFormFields;
